import { API_METHOD, ENDPOINTS } from './appConstants';
import { handleFetch } from './handleFetch';

const apiRoot = ENDPOINTS.API + '/Inspection';


export const getManifest = (customerId, year) => {

	let url = `${apiRoot}/GetCustomerViolations/${customerId}/${year}`;

	const options = {
		method: API_METHOD.GET
	};
	return handleFetch(url, options, true);
}


export const submit = (data) => {

	let url = `${apiRoot}/Submit`;

	const options = {
		method: API_METHOD.POST,
		body: JSON.stringify(data)
	};
	return handleFetch(url, options, true);
}

